import { render, staticRenderFns } from "./FormDocxView.vue?vue&type=template&id=373c8a6a&scoped=true"
import script from "./FormDocxView.vue?vue&type=script&lang=js"
export * from "./FormDocxView.vue?vue&type=script&lang=js"
import style0 from "./FormDocxView.vue?vue&type=style&index=0&id=373c8a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c8a6a",
  null
  
)

export default component.exports